import React from 'react';
import immutable from 'immutable';
import Checkbox from 'material-ui/Checkbox';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import LibraryActions from 'actions/library/LibraryActions';
import LibraryCreateActions from 'actions/library/LibraryCreateActions';
import InlineItemList from 'components/pure/utils/InlineItemList';
import TextField from 'material-ui/TextField';
import Button from '@material-ui/core/Button';
import api from 'sources/api';
import SelectField from 'components/pure/utils/form/SelectField';
import MaterialUITextField from 'components/utils/MaterialUITextField';
import TableWithCheckBoxRows from 'components/utils/TableWithCheckBoxRows';
import ComponentUtils from 'components/ComponentUtils';
import AddUser from 'images/common/AddUser.png';
import Theme from 'styles/theme';
import ConstValues from 'utils/const';
import Cells from './LibraryCells';
import 'styles/lib/forms.styl';
import 'styles/Library.styl';

import confirm from 'utils/confirm';
import {ThemeProvider} from '@components/@theme';
import {lightTheme} from '@components/@theme/lightTheme';
import {distanceBetweenElementAndBottomOfWindow} from 'stores/distanceToBottom';
import {XMarkLargeIcon} from '@components/icon/XMarkLargeIcon';
import {getMuiV4Theme} from 'utils/css/themeUtils';

const contentStyleForCreateLibraryDialog = {
  maxWidth: '646px',
};
const contentStyleForLibraryDeletionDialog = {
  maxWidth: '524px',
};
const contentStyleForTagDeletionDialog = {
  maxWidth: '624px',
};
const classNames = require('classnames');

/**
 * Search tab for the library page.
 */
export default class LibraryCreateDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.utils = new ComponentUtils();
    let state = userSharePermissionStates(props.user);
    state.currentTagSearchToAdd = null;
    state.showConfirmDelete = false;
    state.showConfirmTagDelete = false;
    state.isDeletingTag = false;
    state.shareTypeSearchTerm = '';
    state.shareIdSearchTerm = '';
    state.tagSearchTerm = '';
    state.addTagDropdownDirection = ConstValues.reactSelectize.dropdownDirection.down;
    state.openDropdown = null;
    state.showSharingAndTagSections = false;
    this.state = state;

    this.cancelDeleteLibrary = this.cancelDeleteLibrary.bind(this);
    this.cancelDeleteTag = this.cancelDeleteTag.bind(this);
    this.createTagFromSearch = this.createTagFromSearch.bind(this);
    this.deleteLibrary = this.deleteLibrary.bind(this);
    this.deleteTag = this.deleteTag.bind(this);
    this._filterOptionsByOrderingThemByNumberOfMatchedSubstrings =
      this._filterOptionsByOrderingThemByNumberOfMatchedSubstrings.bind(this);
    this.handleAddShare = this.handleAddShare.bind(this);
    this.handleAddTag = this.handleAddTag.bind(this);
    this.handleCloseDialogRequest = this.handleCloseDialogRequest.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleLibraryNameChange = this.handleLibraryNameChange.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleShareElementChange = this.handleShareElementChange.bind(this);
    this.handleShareTypeChange = this.handleShareTypeChange.bind(this);
    this.handleShareTypeSearchTermChange = this.handleShareTypeSearchTermChange.bind(this);
    this.handleShareIdSearchTermChange = this.handleShareIdSearchTermChange.bind(this);
    this.handleSharingElementOpenChange = this.handleSharingElementOpenChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTagChange = this.handleTagChange.bind(this);
    this.handleTagDelete = this.handleTagDelete.bind(this);
    this.onSearchTagChange = this.onSearchTagChange.bind(this);
    this.renderSharingNoResultsFound = this.renderSharingNoResultsFound.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);

    this.shareTableColumns = [
      {
        id: 'name',
        accessor: 'name',
        Header: 'Library Members',
        style: {
          color: Theme.palette.dialogHeaderDescriptionTextColor,
          textAlign: 'left',
          paddingLeft: '10px',
          paddingRight: '30px',
          width: '150px',
        },
        spanStyle: {textAlign: 'left', margin: '0', display: 'inherit'},
        tdStyle: {textAlign: 'left', width: '150px'},
        tdCellStyle: {textAlign: 'left', paddingLeft: '10px'},
        cell: props => <Cells.LinkCell {...props} />,
      },
      {
        id: 'admin_permission',
        accessor: 'admin_permission',
        Header: 'Admin',
        style: {color: Theme.palette.dialogHeaderDescriptionTextColor},
        cell: props => <Cells.CheckboxCell {...props} />,
      },
      {
        id: 'create_tags_permission',
        accessor: 'create_tags_permission',
        Header: 'Create Tags',
        style: {color: Theme.palette.dialogHeaderDescriptionTextColor},
        cell: props => <Cells.CheckboxCell {...props} />,
      },
      {
        id: 'add_permission',
        accessor: 'add_permission',
        Header: 'Add',
        style: {color: Theme.palette.dialogHeaderDescriptionTextColor},
        cell: props => <Cells.CheckboxCell {...props} />,
      },
      {
        id: 'remove_permission',
        accessor: 'remove_permission',
        Header: 'Remove',
        style: {color: Theme.palette.dialogHeaderDescriptionTextColor},
        cell: props => <Cells.CheckboxCell {...props} />,
      },
      {
        id: 'view_permission',
        accessor: 'view_permission',
        Header: 'View',
        style: {color: Theme.palette.dialogHeaderDescriptionTextColor},
        cell: props => <Cells.CheckCell {...props} />,
      },
      {
        id: 'remove_row',
        accessor: 'remove_row',
        Header: 'Remove Row',
        spanStyle: {display: 'none'},
        cell: props => <Cells.RemoveCell {...props} />,
      },
    ];
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.user.permissions !== this.props.user.permissions) {
      let state = userSharePermissionStates(nextProps.user);
      this.setState(state);
    }
    if (
      nextProps.createForm !== this.props.createForm ||
      nextProps.user !== this.props.user ||
      nextProps.createForm.get('shares') !== this.props.createForm.get('shares')
    ) {
      const shares = immutable.List(nextProps.createForm.get('shares'));
      const libraryPermissionsForUser = this.utils.libraryPermissionsForUser(
        this.props.user,
        shares
      );
      this.setState({libraryPermissionsForUser: libraryPermissionsForUser});
    }
    if (
      nextProps.formState &&
      nextProps.formState.get('tagToRemove') !== this.props.formState.get('tagToRemove')
    ) {
      const tagToRemove = nextProps.formState.get('tagToRemove');
      if (tagToRemove.only_calls_count > 0) {
        this.setState({showConfirmTagDelete: true});
      } else if (this.state.isDeletingTag) {
        this.removeTag(tagToRemove.name);
      }
      this.setState({isDeletingTag: false});
    }
    if (this._isUpdating(nextProps) && !this.state.showSharingAndTagSections) {
      // Update this.state.showSharingAndTagSections according to whether the user has sharing / tags or not
      if (this.shouldRenderSharing() || this.shouldRenderTags()) {
        this.setState({showSharingAndTagSections: true});
      }
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions() {
    this._updateTagDropdownDirectionIfNecessary();
  }

  componentDidUpdate() {
    this._updateTagDropdownDirectionIfNecessary();
  }

  _updateTagDropdownDirectionIfNecessary() {
    if (this._addTagField) {
      const {up, down} = ConstValues.reactSelectize.dropdownDirection;
      if (
        distanceBetweenElementAndBottomOfWindow(this._addTagField) <
        ConstValues.reactSelectize.dropdownHeight
      ) {
        if (this.state.addTagDropdownDirection !== up) {
          this.setState({addTagDropdownDirection: up});
        }
      } else if (this.state.addTagDropdownDirection !== down) {
        this.setState({addTagDropdownDirection: down});
      }
    }
  }

  _userCanViewOthers() {
    let canViewOthers = false;
    const user = this.props.user;
    user.permissions.forEach(perm => {
      if (perm === 'view_all_account' || perm === 'view_team' || perm === 'view_all_department') {
        canViewOthers = true;
      }
    });
    return canViewOthers;
  }

  getShareTypes() {
    let types = [];
    if (this.state.can_share_libraries_globally) {
      types.push({label: 'Everyone', value: 'account'});
    }
    if (
      this.state.can_share_libraries_globally ||
      this.state.can_share_libraries_with_departments
    ) {
      types.push({label: 'Department', value: 'department'});
    }
    if (
      this.state.can_share_libraries_globally ||
      this.state.can_share_libraries_with_departments ||
      this.state.can_share_libraries_with_teams
    ) {
      types.push({label: 'Team', value: 'team'});
    }
    if (this._userCanViewOthers()) {
      types.push({label: 'User', value: 'user'});
    }
    return types;
  }

  handleShareTypeChange(type) {
    setImmediate(() => LibraryCreateActions.changeShareElementType(type));
    if (type === 'account') {
      const {accountId} = this.props.user;
      setImmediate(() => LibraryCreateActions.changeShareElementId(accountId));
    }
  }

  handleShareTypeSearchTermChange(search) {
    this.setState({shareTypeSearchTerm: search});
  }

  getTagsOptions() {
    const tags = immutable.List(this.props.sources.get('accountTags'));
    if (!tags) {
      return [];
    }
    const tagsChosen = immutable.List(this.props.createForm.get('tags'));
    return tags
      .map(tag => {
        return {label: tag, value: tag};
      })
      .filterNot(tag => {
        return tagsChosen.includes(tag.value);
      })
      .toArray();
  }

  getShareListOptions() {
    const type = this.props.createForm.get('shareType');
    if (type === null) {
      return [];
    }
    let lst;
    if (type === 'user') {
      const sources = this.props.sources.get(type);
      if (!sources) {
        return [];
      }
      lst = sources.get('list');
    } else {
      const shareAccessible = this.props.shareAccessible.get(type);
      if (!shareAccessible) {
        return [];
      }
      lst = shareAccessible.get('list');
    }
    return this._shareListOptions(lst);
  }

  _filterOptionsByOrderingThemByNumberOfMatchedSubstrings(options, search) {
    let optionsList = immutable.List(options);
    if (this.props.createForm.get('shareType') !== 'user') {
      optionsList = optionsList.filter(item => {
        return item.label.toLowerCase().indexOf(search.toLowerCase()) > -1;
      });
    }
    if (search && search.length > 0) {
      const searchWords = search.split(' ');
      return optionsList
        .sort((optionA, optionB) => {
          const optionANumberOfSubstrings = this._numberOfSubstringWithinCaseInsensitive(
            searchWords,
            optionA.label
          );
          const optionBNumberOfSubstrings = this._numberOfSubstringWithinCaseInsensitive(
            searchWords,
            optionB.label
          );
          if (optionANumberOfSubstrings > optionBNumberOfSubstrings) {
            return -1;
          } else if (optionANumberOfSubstrings < optionBNumberOfSubstrings) {
            return 1;
          }
          return 0;
        })
        .toArray();
    }
    return optionsList.toArray();
  }

  _numberOfSubstringWithinCaseInsensitive(words, string) {
    let count = 0;
    words.forEach(word => {
      string.split(' ').forEach(stringWord => {
        count += longestSharedSubstring([stringWord, word]).length;
      });
    });
    return count;
  }

  _shareListOptions(lst) {
    const elements = immutable.List(lst);
    const currentShares = immutable
      .List(this.props.createForm.get('shares'))
      .map(share => share.id);
    return elements
      .map(element => {
        return {label: element.name, value: element.id};
      })
      .filterNot(element => {
        return currentShares.includes(element.value);
      })
      .filterNot(element => {
        return element.value === this.props.user.id;
      })
      .toArray();
  }

  _shouldRenderNoResults() {
    const search = this.state.shareIdSearchTerm;
    return search && search.trim().length > 0;
  }

  renderSharingNoResultsFound() {
    if (this._shouldRenderNoResults()) {
      const type = this.props.createForm.get('shareType');
      let noResultsFoundText;
      if (type === 'user') {
        noResultsFoundText = `We couldn't find anybody whose name matches`;
      } else if (type === 'department') {
        noResultsFoundText = `We couldn't find any department whose name matches`;
      } else if (type === 'team') {
        noResultsFoundText = `We couldn't find any team whose name matches`;
      }
      return <div className="no-results-found">{noResultsFoundText}</div>;
    }
    return null;
  }

  handleShareElementChange(elementId) {
    setTimeout(() => {
      LibraryCreateActions.changeShareElementId(elementId);
      const type = this.props.createForm.get('shareType');
      this._handleAddShare(type, elementId);
    }, 0);
  }

  handleSharingElementOpenChange(open) {
    if (open) {
      this.setState({openDropdown: 'sharingElement'});
    } else {
      this.setState({openDropdown: null});
    }
  }

  handleShareIdSearchTermChange(search) {
    this.setState({shareIdSearchTerm: search});
    if (this.props.createForm.get('shareType') === 'user' && search && search.trim().length > 0) {
      this.loadAsyncUserOptions(search);
    }
  }

  loadAsyncUserOptions(search) {
    const config = {baseURL: '/apiv2'};
    return api
      .get('/users/autocomplete?restrict_by_tagger=false&q=' + search, config)
      .then(resp => {
        return resp.data.users;
      })
      .then(users => {
        setImmediate(() => LibraryActions.updateUserList(users));
      });
  }

  handleAddShare() {
    const type = this.props.createForm.get('shareType');
    const id = this.props.createForm.get('shareId');
    this._handleAddShare(type, id);
  }

  _handleAddShare(type, id) {
    if (type === null || id === null) {
      return;
    }
    const shares = this.props.createForm.get('shares');

    const found = shares.findIndex(e => e.id === id);
    if (found > -1) {
      return;
    }

    let element;
    if (type === 'account') {
      element = {type: 'account', id: id, name: 'Everyone'};
    } else {
      let elementMap;
      if (type === 'user') {
        elementMap = this.props.sources.get(type).get('map');
      } else {
        elementMap = this.props.shareAccessible.get(type).get('map');
      }
      element = elementMap.get(id);
    }
    if (!element) {
      if (type === 'user') {
        element = this.props.sources
          .get(type)
          .get('list')
          .find(item => item.id === id);
      } else {
        element = this.props.shareAccessible
          .get(type)
          .get('list')
          .find(item => item.id === id);
      }
    }

    if (element) {
      const newElement = {
        type: element.type,
        id: element.id,
        name: element.name,
        admin_permission: false,
        create_tags_permission: false,
        add_permission: false,
        remove_permission: false,
        view_permission: true,
      };
      setTimeout(() => LibraryCreateActions.addCurrentSharedElement(newElement), 0);
    }
  }

  _addTagButtonIsDisabled() {
    const enabled =
      ((this.props.createForm.get('currentTag') &&
        this.props.createForm.get('currentTag').length > 0) ||
        (this.state.currentTagSearchToAdd && this.state.currentTagSearchToAdd.length > 0)) &&
      this.state.tagSearchTerm &&
      this.state.tagSearchTerm.trim().length > 0;
    return !enabled;
  }

  handleAddTag() {
    const isUpdate = this.props.createForm.get('id');
    if (this.props.createForm.get('currentTag') === null) {
      const currentTagSearchToAdd = this.state.currentTagSearchToAdd;
      const isNewTag =
        this.props.sources.get('tags').indexOf(currentTagSearchToAdd) === -1 &&
        currentTagSearchToAdd.length > 0;
      // Handle the use case when the user wants to click the '+' button while typing a tag search term
      this._handleTagChange(currentTagSearchToAdd, () => {
        setTimeout(() => {
          if (isNewTag) {
            LibraryCreateActions.changeAndAddCurrentTag(currentTagSearchToAdd);
          } else {
            LibraryCreateActions.addCurrentTag(isUpdate);
          }
        }, 100);
      });
    } else {
      setImmediate(() => LibraryCreateActions.addCurrentTag(isUpdate));
    }
    this._clearCurrentTagSearchToAdd();
  }

  _clearCurrentTagSearchToAdd() {
    setTimeout(() => {
      this.setState({
        currentTagSearchToAdd: null,
        tagSearchTerm: '',
      });
    }, 100);
  }

  handleTagChange(tag) {
    this._handleTagChange(tag);
  }

  _handleTagChange(tag, callback = null) {
    if (
      this.state.can_share ||
      this.state.libraryPermissionsForUser.admin ||
      this.state.libraryPermissionsForUser.add
    ) {
      setImmediate(() => LibraryCreateActions.changeAndAddCurrentTag(tag));
    }
    if (callback) {
      callback();
    }
    this._clearCurrentTagSearchToAdd();
  }

  onSearchTagChange(search) {
    let state = {tagSearchTerm: search};
    if (search && search.length > 0) {
      state.currentTagSearchToAdd = search;
    }
    this.setState(state);
  }

  createTagFromSearch(options, search) {
    if (search.length === 0 || options.map(option => option.label).indexOf(search) > -1) {
      return null;
    } else if (
      this.state.can_share ||
      this.state.libraryPermissionsForUser.create_tags ||
      this.state.libraryPermissionsForUser.admin
    ) {
      return {label: search, value: search};
    }
  }

  handleSubmit() {
    const isUpdateForm = this.props.createForm.get('id');
    setImmediate(() =>
      LibraryCreateActions.submit({
        user: this.props.user,
        isUpdateForm: isUpdateForm,
        showSharingAndTagSections: this.state.showSharingAndTagSections,
        adminManage: this.props.adminManage || false,
      })
    );
  }

  closeDialog = () => {
    const closeMainDialog = !!this.props.formState.get('showCreateOrUpdateLibraryDialog');
    const closeConfirmDeleteDialog = this.state.showConfirmDelete;
    const closeTagDeleteDialog = this.state.showConfirmTagDelete;
    const adminManage = Boolean(this.props.adminManage);
    let state = {showSharingAndTagSections: false};

    if (closeTagDeleteDialog) {
      state.showConfirmTagDelete = false;
      this.setState(state);
      return;
    }

    if (closeConfirmDeleteDialog) {
      state.showConfirmDelete = false;
      this.setState(state);
      return;
    }

    if (closeMainDialog) {
      setImmediate(() => LibraryActions.hideCreateOrUpdateLibraryDialog(adminManage));
      setImmediate(() => LibraryCreateActions.clearTags());
    }

    setImmediate(() => LibraryCreateActions.clearUnsavedShare());
    this.setState(state);
  };

  handleCloseDialogRequest() {
    if (this.props.createForm.hasUnsavedShares) {
      confirm(
        'You changed the Library Members with whom you are sharing the library, but the change was not saved. Would you like to save this information?'
      ).then(() => {
        this.handleSubmit();
        this.closeDialog();
      }, this.closeDialog.bind(this));
    } else {
      this.closeDialog();
    }
  }

  handleDelete() {
    this.setState({showConfirmDelete: true});
  }

  deleteLibrary() {
    const adminManage = this.props.adminManage || false;

    setImmediate(() => LibraryCreateActions.deleteLibrary(adminManage));
    this.setState({showConfirmDelete: false});
  }

  cancelDeleteLibrary() {
    this.setState({showConfirmDelete: false});
  }

  canShareWithOthers() {
    let canShareWithOthers = false;
    const shares = immutable.List(this.props.createForm.get('shares'));
    const user = this.props.user;
    shares.forEach(share => {
      // Iterate through all share configurations for the current library and decide whether this.props.user is
      // allowed to manage its sharing or not
      if (
        share.type === 'account' ||
        (share.type === 'user' && share.id !== user.id) ||
        (share.type === 'team' && share.id === user.team_id) ||
        (share.type === 'department' && share.id === user.department_id)
      ) {
        if (!canShareWithOthers) {
          canShareWithOthers = share.admin_permission;
        }
      }
    });
    return canShareWithOthers;
  }

  shouldRenderSharing() {
    let shouldRenderSharing = false;
    if (this.state.can_share) {
      shouldRenderSharing = true;
    } else {
      shouldRenderSharing = this.canShareWithOthers();
    }
    return shouldRenderSharing;
  }

  renderSharing() {
    const shouldRenderSharing = this.shouldRenderSharing();
    if (shouldRenderSharing) {
      const shareElementClassname = classNames('library-form-select share-element', {
        hidden: this.props.createForm.get('shareType') === 'account',
      });
      const buttonAddShareClassname = classNames('submit button-add-share', {
        'no-second-share': this.props.createForm.get('shareType') === 'account',
      });
      const shares = this.props.createForm.get('shares');
      return (
        <div className="sharing-container">
          <div className="pane">
            <div className="pane-header">
              <div className="pane-header-left">Sharing</div>
              <div className="pane-header-right">
                Who should have access to this library, and how can they participate?
              </div>
            </div>
          </div>

          <div className="field">
            <div className="field-left">
              <span>Share with:</span>
            </div>
            <div className="field-right">
              <SelectField
                formState={this.state}
                name="shareType"
                hideResetButton={true}
                tether={false}
                className="library-form-select"
                options={this.getShareTypes()}
                onChange={this.handleShareTypeChange}
                onSearchChange={this.handleShareTypeSearchTermChange}
                updateSearch={this.handleShareTypeSearchTermChange}
                search={this.state.shareTypeSearchTerm}
                value={this.props.createForm.get('shareType')}
              />
              <SelectField
                ref={c => (this._sharingElement = c)}
                formState={this.state}
                name="share_element"
                hideResetButton={true}
                onBlurResetsInput={false}
                tether={false}
                className={shareElementClassname}
                options={this.getShareListOptions()}
                filterOptions={this._filterOptionsByOrderingThemByNumberOfMatchedSubstrings}
                placeholder={`Type to search`}
                renderNoResultsFound={this.renderSharingNoResultsFound}
                onOpenChange={this.handleSharingElementOpenChange}
                onChange={this.handleShareElementChange}
                onSearchChange={this.handleShareIdSearchTermChange}
                updateSearch={this.handleShareIdSearchTermChange}
                search={this.state.shareIdSearchTerm}
                value={this.props.createForm.get('shareId')}
              />
              <IconButton className={buttonAddShareClassname} onClick={this.handleAddShare}>
                <img alt="" src={AddUser} />
              </IconButton>
            </div>
          </div>

          {!shares || shares.length <= 0 ? null : (
            <div className="sharing-table-container">
              <TableWithCheckBoxRows
                columns={immutable.List(this.shareTableColumns)}
                data={shares}
                tableRef={ref => (this.stickyTable = ref)}
              />
            </div>
          )}
        </div>
      );
    }
  }

  removeTag(tag) {
    if (
      this.state.can_share ||
      this.state.libraryPermissionsForUser.admin ||
      this.state.libraryPermissionsForUser.remove
    ) {
      setImmediate(() => LibraryCreateActions.removeTag(tag));
    }
  }

  handleTagDelete(tag) {
    const isUpdateForm = this.props.createForm.get('id');
    if (isUpdateForm) {
      if (
        this.state.can_share ||
        this.state.libraryPermissionsForUser.admin ||
        this.state.libraryPermissionsForUser.remove
      ) {
        this.setState({isDeletingTag: true});
        setImmediate(() => LibraryActions.getLibraryTag(this.props.createForm.get('id'), tag));
      }
    } else {
      this.removeTag(tag);
    }
  }

  shouldRenderTags() {
    let shouldRenderTags = false;
    if (this.state.can_share) {
      shouldRenderTags = true;
    } else {
      shouldRenderTags = this.canShareWithOthers();
    }
    return shouldRenderTags;
  }

  renderTags() {
    const shouldRenderTags = this.shouldRenderTags();
    if (shouldRenderTags) {
      const tagOptions = this.getTagsOptions();
      const currentChosenTags = this.props.createForm.get('tags').sort();
      return (
        <div className="tags-container">
          <div className="pane">
            <div className="pane-header">
              <div className="pane-header-left">Tags</div>
              <div className="pane-header-right">
                What tags can be used in this library? (Anybody with "Create Tag" permission, as
                listed in the Library Members list above, will be able to create additional tags as
                needed).
              </div>
            </div>
          </div>

          <div className="field field-double-margin-top">
            <div className="field-left">
              <span>Add tag:</span>
            </div>
            <div className="field-right fixed-overflow-y add-tag">
              <SelectField
                ref={c => (this._addTagField = c)}
                name="tags"
                hideResetButton={true}
                onBlurResetsInput={false}
                tether={false}
                dropdownDirection={this.state.addTagDropdownDirection}
                className="library-form-select"
                createFromSearch={this.createTagFromSearc}
                renderOption={renderAddTagOption}
                options={tagOptions}
                onChange={this.handleTagChange}
                value={this.props.createForm.get('currentTag')}
                onSearchChange={this.onSearchTagChange}
                search={this.state.tagSearchTerm}
                maxLength={ConstValues.maxCharsInLibraryName}
              />
              <IconButton
                className="submit"
                onClick={this.handleAddTag}
                label="Add"
                disabled={this._addTagButtonIsDisabled()}>
                <i className="material-icons color-primary1">add_box</i>
              </IconButton>
            </div>
          </div>

          {!currentChosenTags || currentChosenTags.length <= 0 ? null : (
            <div className="field field-margin-top">
              <div className="field-left">
                <span className="no-line-height">Tags:</span>
              </div>
              <div className="field-right field-tags">
                <InlineItemList itemList={currentChosenTags} onRemove={this.handleTagDelete} />
              </div>
            </div>
          )}
        </div>
      );
    }
  }

  renderHeaderText(isUpdateForm) {
    if (isUpdateForm) {
      return <span className="title-description">Update an existing library.</span>;
    } else if (this.state.can_share) {
      return (
        <span className="title-description">
          Create a new library. You'll be able to add calls to this library with tags. You can share
          this library with individuals, departments, or teams.
        </span>
      );
    } else {
      return (
        <span className="title-description">
          Create a new personal library. You'll be able to add calls to this library with tags.
        </span>
      );
    }
  }

  handleLibraryNameChange(event) {
    const name = event.target.value;
    if (name.length <= ConstValues.maxCharsInLibraryName) {
      LibraryCreateActions.changeName(name);
    }
  }

  renderLibraryNameAndPurpose() {
    const isWide = !!(this.shouldRenderTags() || this.shouldRenderSharing());
    const libraryNameTextFieldClassname = classNames(
      'text-field name plain-border margin-right-20',
      {
        'wide-text-field': isWide,
      }
    );
    const purposeTextFieldClassname = classNames(
      'text-field purpose plain-border margin-right-20',
      {
        'wide-text-field': isWide,
      }
    );
    return (
      <div className="fields">
        <div className="field">
          <div className="label">Library Name:</div>
          <MaterialUITextField
            autoFocus
            name="name"
            className={libraryNameTextFieldClassname}
            errorText={this.state.nameError}
            hintText=""
            style={{height: '38px'}}
            onChange={this.handleLibraryNameChange}
            value={this.props.createForm.get('name')}>
            <div className="counter">
              {this.props.createForm.get('name').length} / {ConstValues.maxCharsInLibraryName}
            </div>
          </MaterialUITextField>
        </div>
        {this._renderCreateLibraryError()}
        <br />
        <div className="field">
          <div className="label label-purpose">Purpose:</div>
          <TextField
            name="name"
            className={purposeTextFieldClassname}
            errorText={this.state.nameError}
            hintText="What is this library for? What kinds of calls are eligible to be included?"
            hintStyle={{bottom: 'auto', top: '12px'}}
            underlineShow={false}
            multiLine={true}
            onChange={event => LibraryCreateActions.changePurpose(event.target.value)}
            value={this.props.createForm.get('purpose')}
          />
        </div>
      </div>
    );
  }

  _libraryNameIsValid() {
    const name = this.props.createForm.get('name');
    return name && name.length > 0;
  }

  _renderCreateLibraryError() {
    const errorMessage = this.props.formState.get('createOrUpdateLibraryDialogError');
    return errorMessage && errorMessage.indexOf('library') > -1 && !this._libraryNameIsValid()
      ? this._renderErrorMessageDiv(this.props.formState.get('createOrUpdateLibraryDialogError'))
      : null;
  }

  _renderErrorMessageDiv(message, extraClassname = null) {
    const isWide = !!(this.shouldRenderTags() || this.shouldRenderSharing());
    const errorDivClassname = classNames('error-tip', {'wide-error-tip': isWide}, extraClassname);
    return (
      <div className={errorDivClassname}>
        <span>
          <i className="material-icons">error_outline</i>&nbsp;&nbsp;
          {this._errorMessage(message)}
        </span>
      </div>
    );
  }

  _errorMessage(message) {
    if (message.indexOf(':') > -1) {
      return message.split(':')[1];
    }
    return message;
  }

  renderDeleteButtonIfNecessary(isUpdateForm) {
    const library = this.props.sources.get('library');
    if (
      isUpdateForm &&
      library &&
      (this.props.user.id === library.user_id || this.props.adminManage)
    ) {
      return (
        <Button
          variant="outlined"
          className="create-library-button delete ev-button"
          onClick={this.handleDelete}>
          <span className="label">Delete Library</span>
        </Button>
      );
    }
    return null;
  }

  cancelDeleteTag() {
    LibraryActions.updateTagToRemove(null);
    this.setState({showConfirmTagDelete: false});
  }

  deleteTag() {
    const tagToRemove = this.props.formState.get('tagToRemove');
    this.removeTag(tagToRemove.name);
    LibraryActions.updateTagToRemove(null);
    this.setState({showConfirmTagDelete: false});
  }

  renderTagDeleteNotice(tagToRemove) {
    if (tagToRemove) {
      const callCountDescriptor =
        tagToRemove.total_calls_count === 1 ? 'call currently is' : 'calls currently are';
      const countToRemoveDescriptor =
        tagToRemove.only_calls_count === tagToRemove.total_calls_count
          ? tagToRemove.only_calls_count === 1
            ? 'this call'
            : 'these calls'
          : `${tagToRemove.only_calls_count} of these calls`;
      const remainingCallsDescriptor =
        tagToRemove.only_calls_count === tagToRemove.total_calls_count
          ? '.'
          : ' (the remaining calls have other tags, and so would stay in the library.)';
      return (
        <p>
          {tagToRemove.total_calls_count} {callCountDescriptor} tagged "{tagToRemove.name}" in this
          library. Removing this tag from the library will remove {countToRemoveDescriptor} from the
          library
          {remainingCallsDescriptor} Do you wish to proceed?
        </p>
      );
    }
  }

  renderChangeInfo() {
    const isUpdateForm = this.props.createForm.get('id');
    if (!isUpdateForm) {
      return null;
    }

    const initialState = this.props.createForm.get('initialState');

    const formChanged =
      initialState.get('name') !== this.props.createForm.get('name') ||
      initialState.get('purpose') !== this.props.createForm.get('purpose') ||
      initialState.get('shares') !== this.props.createForm.get('shares') ||
      initialState.get('tags') !== this.props.createForm.get('tags');

    if (!formChanged) {
      return null;
    }

    return (
      <div className="change-info">
        Your changes to this library will be saved when you click the Update Library button
      </div>
    );
  }

  handleScroll({target: {offsetWidth, clientWidth, scrollTop}}) {
    if (this.stickyTable) {
      const yTranslation = Math.max(0, scrollTop - this.stickyTable.offsetTop);
      const translate = `translate(0,${yTranslation}px)`;
      this.stickyTable.querySelector('thead').style.transform = translate;
    }
  }

  renderShowSharingAndTagSectionsCheckbox() {
    return (
      <div className="sharing-section-div">
        <Checkbox
          label="Share this library with other users"
          checked={this.state.showSharingAndTagSections}
          onCheck={(event, isChecked) => this.setState({showSharingAndTagSections: isChecked})}
        />
      </div>
    );
  }

  _renderSharingAndTagSections() {
    return (
      <div>
        {this.renderSharing()}
        {this.renderTags()}
      </div>
    );
  }

  _isUpdating(props) {
    return !!props.createForm.get('id');
  }

  render() {
    const open = !!this.props.formState.get('showCreateOrUpdateLibraryDialog');
    const isUpdateForm = this._isUpdating(this.props);
    let dialogTitle = isUpdateForm ? 'Update Library' : 'Create Library';
    const tagToRemove = this.props.formState.get('tagToRemove');
    let contentStyle = contentStyleForCreateLibraryDialog;
    if (this.shouldRenderTags() || this.shouldRenderSharing()) {
      contentStyle = Object.assign({}, contentStyleForCreateLibraryDialog, {
        maxWidth: '850px',
      });
    }

    const actionsClassName = classNames('actions-container', {
      sharing: this.state.can_share,
    });

    return (
      <div>
        <Dialog
          actions={[
            this.renderChangeInfo(),
            <div key={1} className="library-create-actions">
              <ThemeProvider theme={lightTheme}>
                <Button
                  variant="contained"
                  color="primary"
                  className="create-library-button submit ev-button"
                  onClick={this.handleSubmit}>
                  <span className="label">{dialogTitle}</span>
                </Button>
                {this.renderDeleteButtonIfNecessary(isUpdateForm)}
              </ThemeProvider>
            </div>,
          ]}
          actionsContainerClassName={actionsClassName}
          bodyClassName="dialog-body"
          contentStyle={contentStyle}
          open={open}
          modal={false}
          className="create-library-dialog"
          title={dialogTitle}
          titleStyle={{
            borderBottom: 'none',
            color: Theme.palette.dialogHeaderDescriptionTextColor,
          }}
          onRequestClose={this.handleCloseDialogRequest}>
          <XMarkLargeIcon onClick={this.handleCloseDialogRequest} tooltip="Close" />

          <div onScroll={this.handleScroll} className="create-library-body">
            {this.renderHeaderText(isUpdateForm)}
            {this.renderLibraryNameAndPurpose()}

            {this.state.can_share ? this.renderShowSharingAndTagSectionsCheckbox() : null}
            {this.state.showSharingAndTagSections ? this._renderSharingAndTagSections() : null}
          </div>
        </Dialog>
        <Dialog
          contentStyle={contentStyleForLibraryDeletionDialog}
          open={this.state.showConfirmDelete}
          modal={false}
          autoScrollBodyContent={false}
          className="create-library-dialog"
          title={`Warning`}>
          <p className="delete-warning">
            This will irrevocably delete this library. Are you sure?{' '}
          </p>
          <div className="button-row">
            <ThemeProvider theme={getMuiV4Theme()}>
              <Button
                variant="outlined"
                style={{marginLeft: '0px'}}
                labelStyle={{color: 'white', textTransform: 'capitalize'}}
                onClick={this.cancelDeleteLibrary}>
                No, cancel deletion
              </Button>
              <Button variant="contained" color="primary" onClick={this.deleteLibrary}>
                Yes, delete it
              </Button>
            </ThemeProvider>
          </div>
        </Dialog>
        <Dialog
          contentStyle={contentStyleForTagDeletionDialog}
          open={this.state.showConfirmTagDelete}
          modal={false}
          autoScrollBodyContent={false}
          className="create-library-dialog"
          title={`Warning`}>
          {this.renderTagDeleteNotice(tagToRemove)}
          <div className="button-row">
            <ThemeProvider theme={lightTheme}>
              <Button variant="outlined" style={{marginLeft: '0px'}} onClick={this.cancelDeleteTag}>
                No, cancel deletion
              </Button>
              <Button variant="contained" color="primary" onClick={this.deleteTag}>
                Yes, delete it
              </Button>
            </ThemeProvider>
          </div>
        </Dialog>
      </div>
    );
  }
}

function renderAddTagOption(item) {
  return (
    <div className="simple-option" style={{display: 'flex'}}>
      <div>{item.label}</div>
    </div>
  );
}

/**
 * Return the longest shared substring between an array of strings
 * @param array Array of strings
 * @return {string}
 */
function longestSharedSubstring(array) {
  array = array.concat().sort();
  const a1 = array[0];
  const a2 = array[array.length - 1];
  const L = a1.length;
  let i = 0;
  while (i < L && a1.charAt(i) === a2.charAt(i)) {
    i++;
  }
  return a1.substring(0, i);
}

function userSharePermissionStates(user) {
  if (user && user.permissions) {
    const can_share_libraries_globally =
      user.permissions.indexOf('can_share_libraries_globally') > -1;
    const can_share_libraries_with_departments =
      user.permissions.indexOf('can_share_libraries_with_departments') > -1;
    const can_share_libraries_with_teams =
      user.permissions.indexOf('can_share_libraries_with_teams') > -1;
    const can_share =
      can_share_libraries_globally ||
      can_share_libraries_with_departments ||
      can_share_libraries_with_teams;
    return {
      can_share_libraries_globally: can_share_libraries_globally,
      can_share_libraries_with_departments: can_share_libraries_with_departments,
      can_share_libraries_with_teams: can_share_libraries_with_teams,
      can_share: can_share,
    };
  }
}
